<template>
  <div class="withdraw_result_wrapper">
    <div v-if="this.$route.query.status === 'success'" class="result_content">
      <template v-if="isNjPointWithdraw">
        <img src="@/assets/images/img_complete_point.svg" alt="global_withdraw_complete" class="complete_point" />
        <h3>{{ $t('global.withdrawSuccessTitlePoint') }}</h3>
        <p v-html="$t('global.withdrawSuccessDescPoint')" />
      </template>
      <template v-else>
        <img src="@/assets/images/img_complete.svg" alt="global_withdraw_complete" />
        <h3>{{ $t('global.withdrawSuccessTitle') }}</h3>
        <p v-html="$t('global.withdrawSuccessDesc')" />
      </template>
    </div>
    <div v-if="this.$route.query.status === 'fail'" class="result_content">
      <img src="@/assets/images/img_error.svg" alt="global_withdraw_error" />
      <h3 v-html="$t('global.withdrawFail')" />
    </div>
    <div v-if="!this.$route.query.status" class="result_content">
      <h3>{{ $t('error.common.errorPath') }}</h3>
    </div>
    <div class="button_wrapper">
      <button class="btn btn01" @click="handleClick()">{{ $t('common.confirm') }}</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  created() {},
  computed: {
    ...mapGetters('exchange', ['isNjPointWithdraw']),
  },
  methods: {
    handleClick() {
      const tipalti = localStorage.getItem('tipalti');

      if (tipalti) {
        const { uiCulture, serviceUrl, lang } = JSON.parse(tipalti);

        localStorage.removeItem('tipalti');

        let queryString = '';
        if (this.$route.query && this.$route.query.ifpf) {
          queryString = `?ifpf=${this.$route.query.ifpf}`;
        }

        if (this.$route.query.status === 'success') {
          this.$router.push(`/${lang}/${serviceUrl}/exchangeHistory${queryString}`);
        } else {
          this.$router.push(`/${lang}/${serviceUrl}/globalWithdraw${queryString}`);
        }
      } else {
        this.$router.push({ name: 'ExchangeHistory', query: { ...this.$route.query } });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.withdraw_result_wrapper {
  padding: 18px 0 29px;
}
.result_content {
  text-align: center;
  h3 {
    font-family: 'NEXONLv1Gothic';
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: #333;
  }
  p {
    margin-top: 30px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #666;
  }
  .complete_point {
    margin-bottom: 16px;
  }
  img {
    margin: 30px 0;
  }
}
.button_wrapper {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}
</style>
